//@ts-ignore
import * as securitypackage from '@securitypackage-api';


const statusApi = {
	security: {
		package: securitypackage as typeof securitypackageApi,
		directory: {
			client: new securitypackage.DirectoryServiceClient() as DirectoryServiceClient,
			fetchStatus: () => {
				return new Promise<PartnerStatus>(resolve => {
					const request = new securitypackage.PartnerStatusRequest() as PartnerStatusRequest
					statusApi.security.directory.client.getPartnerStatus(request, result => {
						resolve(result);
					});
				});
			},
		},
	},
};

export default statusApi;
